<script>
    import { http } from '@/system/http.js';
    import Flatpickr from 'flatpickr';
    import hasSelectedProducts from '@/online_booking/new/mixins/hasSelectedProducts.js';
    import { mapGetters } from 'vuex';

    //@TODO - This localization can possibly be done in a more dynamic / nice way
    import { Danish } from 'flatpickr/dist/l10n/da.js';
    import { Swedish } from 'flatpickr/dist/l10n/sv.js';

    if (moment_locale == "da") {
        Flatpickr.localize(Danish)
    } else if(moment_locale == "sv") {
        Flatpickr.localize(Swedish)
    }

    Flatpickr.l10ns.default.firstDayOfWeek = 1;

    export default {
        mixins: [hasSelectedProducts],

        props: {
            soonestLoading: {
                type: Boolean,
                default: false,
            },
            isWaitingListEnabled: {
                type: Boolean,
                required: true
            },
        },

        data() {
            return {
                first_step: null,
                second_step: null,
                permalink: null,
                calendar: null,
                loading: false,
                datepicker: null,
                nextAvailable: null,
                selectedDate: null,
            };
        },

        mounted() {
            var self = this;

            this.datepicker = $("#datepicker").flatpickr({
                inline: true,
                weekNumbers: true,
                minDate: moment().format('YYYY-MM-DD'),
                disable: [function (date) {
                    return true;
                }],
                onChange: function (selectedDates, dateStr) {
                    if (dateStr) {
                        self.$event_bus.$emit('dateClicked', {selected: moment(dateStr), next_available: null});
                    }
                },
                onMonthChange: function (selectedDates, dateStr, instance) {
                    self.getAvailableTimesCurrentMonth(instance.currentYear, instance.currentMonth + 1);
                },
                onYearChange: function (selectedDates, dateStr, instance) {
                    self.getAvailableTimesCurrentMonth(instance.currentYear, instance.currentMonth + 1);
                }
            });

            this.$event_bus.$on('ProductsShowed', () => {
                if (this.first_step == 'products') {
                    this.calendar = null;
                }
            });

            this.$event_bus.$on('productsChosen', () => {
                if (
                    !this.waitingListOnly && (
                        (this.first_step == 'calendar' && this.hasSelectedProducts && this.calendar)
                        || (this.first_step == 'products' && this.hasSelectedProducts && this.second_step == 'times')
                    )
                ) {
                    this.getAvailableTimesCurrentMonth(+(moment().format('YYYY')), +(moment().format('MM')));
                }
            });

            this.$event_bus.$on('addonProductsChosen', () => {
                if (
                    !this.waitingListOnly && (
                        (this.first_step == 'calendar' && this.hasSelectedProducts && this.calendar)
                        || (this.first_step == 'products' && this.hasSelectedProducts && this.second_step == 'times')
                    )
                ) {
                    this.getAvailableTimesCurrentMonth(+(moment().format('YYYY')), +(moment().format('MM')));
                }
            });

            this.$event_bus.$on('CalendarClicked', (calendar) => {
                this.calendar = calendar;

                if (this.first_step == 'products' && this.hasSelectedProducts && this.calendar && this.second_step != 'times') {
                    this.getAvailableTimesCurrentMonth(+(moment().format('YYYY')), +(moment().format('MM')));
                }
            });

            this.$event_bus.$on('LoadData', (data) => {
                this.permalink = data.permalink;
                this.first_step = data.online_booking_settings.first_step;
                this.second_step = data.online_booking_settings.second_step;
            });

            this.$event_bus.$on('nextAvailable', () => {
                const nextAvailableDate = moment(this.nextAvailable);
                this.getAvailableTimesCurrentMonth(nextAvailableDate.year(), nextAvailableDate.month() + 1);
            });
        },

        beforeUnmount() {
            this.$event_bus.$off('CalendarClicked');
            this.$event_bus.$off('LoadData');
            this.$event_bus.$off('nextAvailable');
            this.$event_bus.$off('productsChosen');
        },

        computed: {
            ...mapGetters('OnlineBooking', ['waitingListOnly']),
        },

        methods: {
            getAvailableTimesCurrentMonth(year, month) {
                var self = this;
                this.loading = true;

                http.post('/online_booking/getAvailableTimesInMonth', {
                    calendar_id: this.calendar ? this.calendar.id : null,
                    permalink: this.permalink,
                    product_ids: this.selectedProductIds.concat(this.selectedAddonProductIds),
                    year: year,
                    month: month
                })
                    .then(({data}) => {
                        let enabled_days = data.available_times;
                        const selectedDate = enabled_days ? enabled_days[0] : '';

                        if (this.isWaitingListEnabled) {
                            enabled_days = enabled_days.concat(data.fully_booked_times);
                        }

                        const first_date_month = moment(enabled_days[0]).month() + 1;

                        if (enabled_days.length > 0 && first_date_month == month) {
                            const selectedDate = enabled_days[0];
                            this.selectedDate = selectedDate;

                            this.datepicker = $("#datepicker").flatpickr({
                                inline: true,
                                weekNumbers: true,
                                minDate: moment().format('YYYY-MM-DD'),
                                enable: enabled_days,
                                defaultDate: selectedDate,
                                onChange: (selectedDates, dateStr) => {
                                    if (dateStr) {
                                        self.$event_bus.$emit('dateClicked', {selected: moment(dateStr), next_available: null});

                                        if(this.isWaitingListEnabled) {
                                            this.selectedDate = this.formatDate(dateStr);
                                            this.datepicker.redraw();
                                        }
                                    }
                                },
                                onMonthChange: function (selectedDates, dateStr, instance) {
                                    self.getAvailableTimesCurrentMonth(instance.currentYear, instance.currentMonth + 1);
                                },
                                onDayCreate: (dObj, dStr, fp, dayElem) => {
                                    if (!this.isWaitingListEnabled) return;

                                    const formattedCalendarDay = this.formatDate(dayElem.dateObj);
                                    const hasAvailableTime = data.available_times.some(time => this.formatDate(time) === formattedCalendarDay);
                                    const isDisabledDate = dayElem.classList.contains('flatpickr-disabled');
                                    const isSelectedDate = this.selectedDate === formattedCalendarDay;

                                    if (isDisabledDate || hasAvailableTime || isSelectedDate) return;

                                    if (this.calendar && this.calendar.waiting_list) {
                                        const iconHTML = '<i class="fa-duotone fa-clock fa-sm n-color-text-weaker"></i>';
                                        dayElem.innerHTML += iconHTML;
                                        dayElem.title = trans('online_booking.fully_booked_but_has_waiting_list');
                                    }
                                    else{
                                        dayElem.classList.add('flatpickr-disabled');
                                    }
                                },
                            });

                            this.nextAvailable = data.available_times[0];

                            this.$event_bus.$emit('dateClicked', {selected: moment(selectedDate), next_available: null});

                        } else {
                            this.nextAvailable = data.next_available_times[0];
                            const nextAvailableTime = moment(this.nextAvailable);

                            if (this.nextAvailable) {
                                const next_available_date_month = nextAvailableTime.month() + 1;

                                if (next_available_date_month !== month) {
                                    return this.getAvailableTimesCurrentMonth(nextAvailableTime.year(), next_available_date_month);
                                }

                                this.datepicker.jumpToDate(moment(this.nextAvailable).format('YYYY-MM-DD'));
                            } else {
                                let selectedDate = moment(year + '-' + month + '-01', 'YYYY-M-DD');

                                if (selectedDate.isBefore(moment())) {
                                    selectedDate = moment();
                                }

                                this.datepicker.jumpToDate(selectedDate.format('YYYY-MM-DD'));
                            }

                            this.$event_bus.$emit('dateClicked', {selected: null, next_available: this.nextAvailable});
                        }

                        this.loading = false;
                    })
                    .catch(() => {
                        this.loading = false;
                    });
            },
            formatDate(date) {
                return moment(date).format('YYYY-MM-DD');
            }
        },
    }
</script>

<style>
    .flatpickr-calendar:before, .flatpickr-calendar:after {
        display: none;
    }
</style>

<template>
    <div style="position:relative;">
        <div class="datepicker-preloader" v-if="loading || soonestLoading">
            <div class="preloader"></div>
        </div>
        <div id="datepicker"></div>
    </div>
</template>
